import React, { useEffect, useState } from 'react';
import HomeIcon from '@mui/icons-material/Home';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import AddIcon from '@mui/icons-material/Add';
import FavoriteBorderIcon from '@mui/icons-material/FavoriteBorder';
import FavoriteIcon from '@mui/icons-material/Favorite';
import SearchIcon from '@mui/icons-material/Search';
import { useHistory } from 'react-router-dom';
import PropTypes from 'prop-types';
import Container, { MiddleButton } from './styles';
import Item from './Item';
import { colors } from '../../theme/helpers';

const BottomMenu = ({ toggleModal, isConnected }) => {
  const history = useHistory();
  const [actualPath, setActualPath] = useState(window.location.pathname);

  useEffect(
    () =>
      history.listen((location) => {
        setActualPath(location.pathname);
      }),
    [history],
  );

  return (
    <Container>
      <Item
        FirstIcon={HomeIcon}
        SecondIcon={HomeOutlinedIcon}
        color={colors.primaryPeach}
        text="Accueil"
        path="/"
        actualPath={actualPath}
      />
      <MiddleButton onClick={isConnected ? toggleModal : () => {}}>
        <AddIcon fontSize="large" style={{ color: 'white' }} />
        {window.innerWidth >= 992 && <p>Offrir un villageois</p>}
      </MiddleButton>
            <Item
        FirstIcon={SearchIcon}
        SecondIcon={SearchIcon}
        color={colors.primaryPeach}
        text="Rechercher"
        path="/search"
        actualPath={actualPath}
      />
      <Item
        FirstIcon={FavoriteIcon}
        SecondIcon={FavoriteBorderIcon}
        color={colors.primaryPeach}
        text="Wishlist"
        path="/wishlist"
        actualPath={actualPath}
      />
    </Container>
  );
};

BottomMenu.propTypes = {
  toggleModal: PropTypes.func.isRequired,
  isConnected: PropTypes.bool.isRequired,
};

export default BottomMenu;
